<template>
    <div class="container">
        <CoachAdminTable :coach-admins="coachAdmins" />
    </div>
</template>

<script>
import CoachAdminTable from '@components/CoachAdminMaster/CoachAdminTable'

export default {
    components: {
        CoachAdminTable
    },
    props: {
        coachAdmins: {
            type: Array,
            required: true
        }
    }
}
</script>
